<template>
	<nk-page commercialAccess="Salary" :policyClaims="{ or: [`Salary_SalaryItem_Add`, `Salary_SalaryItem_Edit`] }" body-class="d-flex flex-column" :buttons="Object.values(bottomButtons)">
		<template #badges>
			<nk-badge system="Salary">
				<nk-badge-item type="system" modelValue="salary"></nk-badge-item>
				<nk-badge-item type="system" modelValue="salary" :title="$t('forms.salaryItem')"></nk-badge-item>
				<nk-badge-item type="edition" :modelValue="settings.mode === FORM_MODES.READONLY ? FORM_MODES.READONLY : (isEmpty(localData.id) ? 'new' : 'edit')"></nk-badge-item>
			</nk-badge>
		</template>
		<div class="container-fluid h-100">
			<div class="row flex-row-reverse h-100 form-container">
				<div class="w-100">
					<nk-stabs class="nk-card" :activeTab="'item-info'" :tabindex="100" :scrollable="true">
						<nk-stab :id="'item-info'" :name="$t('salary.item-information')">
							<div class="row ">
								<div class="col-12 ">
									<div class="row">
										<div class="col-12 col-sm-4">
											<nk-col-form-group :label="$t('salary.item.active') + ':'" :labelSizes="{ sm: 4 }" :dataSizes="{ sm: 8 }">
												<nk-switch v-model="localData.isActive" :tabindex="101"></nk-switch>
											</nk-col-form-group>
										</div>
									</div>
									<div class="row">
										<div class="col-12 col-sm-4">
											<nk-col-form-group :label="$t('salary.item.item-code') + ':'" :labelSizes="{ sm: 4 }" :dataSizes="{ sm: 8 }">
												<nk-input :options="componentOptions.code" v-model="localData.code" :tabindex="102" @blur="onBlurCode" ref="inputCode" @searchClick="allItems" :disabled="FORM_MODES.READONLY === settings.mode"></nk-input>
											</nk-col-form-group>
										</div>
										<div class="col-12 col-sm-4">
											<nk-col-form-group :label="$t('salary.item.item-name') + ':'" :labelSizes="{ sm: 4 }" :dataSizes="{ sm: 8 }">
												<nk-input :options="componentOptions.name" v-model="localData.name" @update:model-value="(val: string) => { if (retrieveIsEmpty()) localData.displayName = val }" :tabindex="103" :disabled="FORM_MODES.READONLY === settings.mode" startup></nk-input>
											</nk-col-form-group>
										</div>
										<div class="col-12 col-sm-4">
											<nk-col-form-group :label="$t('salary.item.display-name') + ':'" :labelSizes="{ sm: 4 }" :dataSizes="{ sm: 8 }">
												<nk-input :options="componentOptions.displayName" v-model="localData.displayName" :tabindex="104" :disabled="FORM_MODES.READONLY === settings.mode"></nk-input>
											</nk-col-form-group>
										</div>
									</div>
									<div class="row">
										<div class="col-12 col-sm-4">
											<nk-col-form-group :label="$t('salary.item.data-type') + ':'" :labelSizes="{ sm: 4 }" :dataSizes="{ sm: 8 }">
												<nk-dropdown v-model="localData.selectedDataType" :data="dataTypes" :options="componentOptions.dataType" :tabindex="106" :disabled="FORM_MODES.READONLY === settings.mode"></nk-dropdown>
											</nk-col-form-group>
										</div>
										<div class="col-12 col-sm-4">
											<nk-col-form-group :label="$t('salary.item.function-type') + ':'" :labelSizes="{ sm: 4 }" :dataSizes="{ sm: 8 }">
												<nk-dropdown v-model="localData.selectedFunctionType" :data="filteredFunctionTypes" :options="componentOptions.functionType" :tabindex="107" :disabled="FORM_MODES.READONLY === settings.mode"></nk-dropdown>
											</nk-col-form-group>
										</div>
										<div class="col-12 col-sm-4">
											<nk-col-form-group :label="$t('salary.item.data-entry') + ':'" :labelSizes="{ sm: 4 }" :dataSizes="{ sm: 8 }">
												<nk-dropdown v-model="localData.selectedDataEntry" :data="entryTypes" :options="componentOptions.dataEntry" :tabindex="108" :disabled="FORM_MODES.READONLY === settings.mode"></nk-dropdown>
											</nk-col-form-group>
										</div>
									</div>
									<div class="row">
										<div class="col-12 col-sm-4">
											<nk-col-form-group :label="$t('salary.item.item-type') + ':'" :labelSizes="{ sm: 4 }" :dataSizes="{ sm: 8 }">
												<nk-dropdown v-model="localData.selectedItemType" @update:modelValue="ignoreNonPrivilegeCalcChanged(false)" :data="itemTypes" :options="componentOptions.itemType" :tabindex="110" :disabled="FORM_MODES.READONLY === settings.mode"></nk-dropdown>
											</nk-col-form-group>
										</div>
										<div class="col-12 col-sm-4">
											<nk-col-form-group :label="$t('salary.item.default-value') + ':'" :labelSizes="{ sm: 4 }" :dataSizes="{ sm: 8 }">
												<nk-input v-if="!localData.selectedDataType || localData.selectedDataType?.id !== SalaryItemDataTypes.Date" :options="localData.selectedDataType?.id === SalaryItemDataTypes.Time ? componentOptions.defaultValueTime : componentOptions.defaultValue" v-model="localData.defaultValue" :tabindex="111" :disabled="FORM_MODES.READONLY === settings.mode"></nk-input>
												<nk-date v-if="localData.selectedDataType?.id === SalaryItemDataTypes.Date" ref="docDate" :disabled="FORM_MODES.READONLY === settings.mode ? true : null" :options="componentOptions.defaultValueDate" v-model="localData.defaultValue" :tabindex="111"></nk-date>

											</nk-col-form-group>
										</div>
										<div v-if="localData.selectedDataType && ![SalaryItemDataTypes.Date, SalaryItemDataTypes.String].some((x: string) => localData.selectedDataType?.id === x)" class="col-12 col-sm-4">
											<nk-col-form-group :label="$t('salary.item.max-value') + ':'" :labelSizes="{ sm: 4 }" :dataSizes="{ sm: 8 }">
												<nk-input v-if="localData.selectedDataType.id === SalaryItemDataTypes.Time" :options="componentOptions.defaultValueTime" v-model="timeMaxValue" :tabindex="112" :disabled="FORM_MODES.READONLY === settings.mode"></nk-input>
												<nk-input v-else :options="componentOptions.maxValue" v-model="localData.maxValue" :tabindex="112" :disabled="FORM_MODES.READONLY === settings.mode"></nk-input>
												<!--												<nk-date v-if="localData.selectedDataType?.id === SalaryItemDataTypes.Date" ref="docDate" :disabled="FORM_MODES.READONLY === settings.mode ? true : null" :options="componentOptions.maxValueDate" v-model="localData.maxValue" :tabindex="112"></nk-date>-->

											</nk-col-form-group>
										</div>
									</div>
									<div class="row">
										<!--									<div class="col-12 col-sm-4">-->
										<!--										<nk-col-form-group :label="$t('salary.item.equal-item') + ':'" :labelSizes="{sm:4}" :dataSizes="{sm:8}">-->
										<!--											<nk-dropdown v-model="localData.selectedEqualItem" :data="equalItems" :options="componentOptions.equalItem" :tabindex="113" :disabled="FORM_MODES.READONLY === settings.mode"></nk-dropdown>-->
										<!--										</nk-col-form-group>-->
										<!--									</div>-->
									</div>
									<div class="row">
										<div class="col-12 col-sm-4">
											<nk-col-form-group :label="$t('salary.item.account') + ':'" :labelSizes="{ sm: 4 }" :dataSizes="{ sm: 8 }">
												<nk-dropdown-account v-model="localData.selectedAccount" :options="componentOptions.account" :tabindex="113" :disabled="FORM_MODES.READONLY === settings.mode"></nk-dropdown-account>
											</nk-col-form-group>
										</div>

										<div class="col-12 col-sm-4">
											<nk-col-form-group :label="$t('salary.item.include-insurance') + ':'" :labelSizes="{ sm: 10 }" :dataSizes="{ sm: 2 }">
												<nk-checkbox type="checkbox" @update:modelValue="(val: boolean) => { localData.includeInsurance = val; ignoreNonPrivilegeCalcChanged(false) }" :checked="localData.includeInsurance" :disabled="FORM_MODES.READONLY === settings.mode" :tabindex="114" />
											</nk-col-form-group>
										</div>
										<div class="col-12 col-sm-4">
											<nk-col-form-group :label="$t('salary.item.include-tax') + ':'" :labelSizes="{ sm: 4 }" :dataSizes="{ sm: 8 }">
												<div class="d-flex">
													<nk-checkbox type="checkbox" @update:modelValue="(val: boolean) => { localData.includeTax = val; ignoreNonPrivilegeCalcChanged(false) }" :checked="localData.includeTax" :disabled="FORM_MODES.READONLY === settings.mode" :tabindex="115" />
													<label v-show="localData.selectedItemType?.id === 'Deductions'" class="mt-1" style="text-align: center">{{ '( ' + $t('salary.item.decrease-tax') + ' )' }}</label>
												</div>
											</nk-col-form-group>
										</div>
										<div class="col-12 col-sm-4">
											<nk-col-form-group :label="$t('salary.item.resultFunction') + ':'" :labelSizes="{ sm: 4 }" :dataSizes="{ sm: 8 }">
												<nk-dropdown v-model="localData.resultFunctionCode" :data="resultMethods" :options="componentOptions.resultMethods" :tabindex="116"></nk-dropdown>
											</nk-col-form-group>
										</div>
										<div class="col-12 col-sm-4">
											<nk-col-form-group :label="$t('salary.item.continuous') + ':'" :labelSizes="{ sm: 10 }" :dataSizes="{ sm: 2 }">
												<nk-checkbox type="checkbox" @update:modelValue="(val: boolean) => localData.continuous = val" :checked="localData.continuous" :disabled="FORM_MODES.READONLY === settings.mode" :tabindex="117" />
											</nk-col-form-group>
										</div>
										<div class="col-12 col-sm-4">
											<nk-col-form-group :label="$t('salary.item.nonCash') + ':'" :labelSizes="{ sm: 4 }" :dataSizes="{ sm: 8 }">
												<nk-checkbox type="checkbox" @update:modelValue="(val: boolean) => localData.nonCash = val" :checked="localData.nonCash" :disabled="FORM_MODES.READONLY === settings.mode" :tabindex="118" />
											</nk-col-form-group>
										</div>
										<div class="col-12 col-sm-4">
											<nk-col-form-group :label="$t('salary.item.orderIndex') + ':'" :labelSizes="{ sm: 4 }" :dataSizes="{ sm: 8 }">
												<nk-input :options="componentOptions.number" v-model="localData.orderIndex" :tabindex="119" :disabled="FORM_MODES.READONLY === settings.mode" :tabIndex="119"></nk-input>
											</nk-col-form-group>
										</div>
										<div class="col-12 col-sm-4" v-show="localData.type === SalaryItemTypes.Privilege">
											<nk-col-form-group :label="$t('salary.item.ignoreNonPrivilegeCalc') + ':'" :labelSizes="{ sm: 10 }" :dataSizes="{ sm: 2 }">
												<nk-checkbox type="checkbox" @update:modelValue="(val: boolean) => ignoreNonPrivilegeCalcChanged(val)" :checked="localData.ignoreNonPrivilegeCalc" :disabled="FORM_MODES.READONLY === settings.mode" :tabIndex="120" />
											</nk-col-form-group>
										</div>
									</div>
								</div>
							</div>
						</nk-stab>
					</nk-stabs>
					<div v-show="localData.selectedFunctionType?.id === SalaryItemActionTypes.Computational" class="nk-card ">
						<nk-stabs :activeTab="'define-function'" :scrollable="false" :tabindex="0">
							<nk-stab :id="'define-function'" :name="$t('salary.item.define-function')">
								<div class="row mt-1">
									<div class="col-12 col-sm-3">
										<div class="grid-wrapper nk-border-radius-extra nk-bg-gray p-3 px-3 pt-3 mb-2">
											<div @click="addToEditor('/')" column="4" row="1" class="operator">&divide;</div>
											<div @click="addToEditor('number', '3')" column="3" row="1">3</div>
											<div @click="addToEditor('number', '2')" column="2" row="1">2</div>
											<div @click="addToEditor('number', '1')" column="1" row="1">1</div>

											<div @click="addToEditor('*')" column="4" row="1" class="operator">x</div>
											<div @click="addToEditor('number', '6')" column="3" row="1">6</div>
											<div @click="addToEditor('number', '5')" column="2" row="1">5</div>
											<div @click="addToEditor('number', '4')" column="1" row="1">4</div>

											<div @click="addToEditor('-')" column="4" row="1" class="operator">-</div>
											<div @click="addToEditor('number', '9')" column="3" row="1">9</div>
											<div @click="addToEditor('number', '8')" column="2" row="1">8</div>
											<div @click="addToEditor('number', '7')" column="1" row="1">7</div>

											<div @click="addToEditor('+')" column="4" row="1" class="operator">+</div>
											<div column="2" row="1" class="parentheses">
												<div @click="addToEditor(')')" class="parentheses w-50">(</div>
												<div @click="addToEditor('(')" class="parentheses w-50">)</div>
											</div>
											<div @click="addToEditor('number', '0')" column="3" row="1">0</div>
											<div @click="addToEditor('number', '.')" column="1" row="1" class="text-large">.</div>

										</div>
										<div class="nk-bg-gray p-2 text-center  nk-border-radius-extra pb-4">
											<label class="font-weight-bold font-medium">{{ $t('salary.item.contract-fields') }}</label>
											<div class="y-overflow-auto" style="height: 95px;">
												<div v-for="item in contractFields" class="bg-white nk-border-radius w-100 pl-1 pr-2 mb-1 " style="border-radius: 7px">
													<div class="d-flex justify-content-between cursor-pointer">
														<label @click="addToEditor('contractField', { displayName: item.pName, field: item.name })" class="font-weight-light font-weight-bolder">{{ item.pName }}</label>
													</div>
												</div>
											</div>
										</div>

									</div>
									<div class="col-12 col-sm-9 pr-1">
										<div class="border nk-border-radius-extra w-100 mb-1" style="">
											<Editor :expression="localData.jsonFormula" ref="editor" />
										</div>
										<div class="row no-gutters mt-2">
											<div class="col-12 col-sm-8 ">
												<div class="nk-bg-gray p-2 text-center  nk-border-radius-extra   d-flex flex-column ml-2 h-100" style="">
													<label class="font-weight-bold font-medium ">{{ $t('salary.item.salary-items') }}</label>
													<ag-grid class="flex-grow-1" :options="tableOption" :data="itemsWithoutCurrent" v-model="selectedRow" @row_db-clicked="(val: SalaryItem) => addToEditor('salaryItem', { title: val.name, code: val.id })"></ag-grid>
												</div>
											</div>
											<div class="col-12 col-sm-4">
												<!--											variable section-->
												<div class="nk-bg-gray p-2 text-center  nk-border-radius-extra pb-4 mb-1">
													<div class="d-flex justify-content-between px-2">
														<label class="font-weight-bold font-medium " style="margin-right: 40%">{{ $t('salary.item.variables') }}</label>
														<icon class="pt-2 cursor-pointer" icon="plus" group="solid" @click="modifyVariable"></icon>
													</div>
													<div class="y-overflow-auto " style="height: 90px;">
														<div v-for="variable in variables" class="bg-white nk-border-radius w-100 px-2 mb-1 " style="border-radius: 7px">
															<div class="d-flex justify-content-between pt-1" @click="addToEditor('variable', { displayName: variable.title, code: variable.id })">
																<div class="d-flex justify-content-between cursor-pointer w-75">
																	<label class="font-weight-light font-weight-bolder ">{{ variable.title }}</label>
																	<label class="font-weight-light ">{{ $t('salary.variable.value') + ' : ' + variable.value }}</label>
																</div>
																<div tabindex="0" class="text-left  group-buttons">
																	<nk-button v-for="button in variableButtons" :class="button.class" @click="() => button.handler(variable)" @submit="button.handler" :options="button.options" class="" />
																</div>
															</div>
														</div>
														<div v-if="!variables.length" class="bg-white nk-border-radius w-100 px-2 mb-1 text-center font-weight-light">{{ $t('notifications.not-found-any') }}</div>
													</div>
												</div>
												<!--											function section-->
												<div class="nk-bg-gray p-2 text-center  nk-border-radius-extra pb-4">
													<label class="font-weight-bold font-medium">{{ $t('salary.item.functions') }}</label>
													<div class="y-overflow-auto" style="min-height: 150px;">
														<div v-for="func in functions" class="bg-white nk-border-radius w-100 pl-1 pr-2 mb-1 " style="border-radius: 7px">
															<div @click="addToEditor('function', { displayName: func.pName, func: func.name, min: func.minArg, max: func.maxArg })" class="d-flex flex-nowrap justify-content-between x-overflow-auto cursor-pointer">
																<label class="font-weight-light font-weight-bolder ">{{ func.pName }}</label>
																<label class="font-weight-light ">{{ func.argument }}</label>
															</div>
														</div>
													</div>
												</div>

											</div>
										</div>
									</div>
								</div>
							</nk-stab>
						</nk-stabs>
					</div>
				</div>
			</div>
		</div>
	</nk-page>
</template>

<script lang="ts">
	import { defineComponent, PropType } from 'vue'
	import { ConvSalaryItem, dataTypes, entryTypes, itemTypes, operationTypes, SalaryItem, SelectedDataEntry, SelectedDataType, SelectedFunctionType, SelectedItemType } from '@/classes/salary/salary-item'
	import { SalaryItemActionTypes, SalaryItemDataTypes, SalaryItemTypes } from '@/enums/salary'
	import nkTag from '@/components/general/nk-tag.vue'
	import $sc from '@/plugins/shortcut.collection'
	import validators, { Checker, isEmpty, VCustom } from '@/statics/validators'
	import Endpoints from '@nikan/endpoints'
	import { post } from '@/plugins/nikan-api'
	import emptyId from '@/statics/empty-id'
	import dialog from '@/plugins/nikan-dialog-plugin'
	import { TYPE } from 'vue-toastification'
	import TabOrder from '@/statics/taborder-functions'
	import { IStringMap } from '@/classes/salary/salary-period'
	import salaryItemList from '@/views/salary/salary-item/salary-item-list.vue'
	import isEqual from 'lodash/isEqual'
	import { IResponse, IResponseList } from '@/interfaces/base'
	import merge from 'lodash/merge'
	import cloneDeep from 'lodash/cloneDeep'
	import { ConvFunction } from '@/classes/salary/function'
	import { mapActions } from 'vuex'
	import modifyVariable from '@/views/salary/salary-item/modify-variable.vue'
	import { SalaryVariable } from '@/classes/salary/salary-variable'
	import { ResultFunction } from '@/classes/salary/result-function'

	export default defineComponent({
		name: "salary-item-modify",
		modal: {
			size: 'fullscreen',
			stateUID: 'salary-item-modify',
			helpTag: 'SalaryItemModify'
		},
		props: {
			options: Object,
			data: {
				type: Object as PropType<ConvSalaryItem>,
				required: false
			},
		},
		computed: {
			SalaryItemActionTypes() {
				return SalaryItemActionTypes
			},
			SalaryItem() {
				return SalaryItem
			},
			SalaryItemDataTypes() {
				return SalaryItemDataTypes
			},
			filteredFunctionTypes() {
				if (this.localData.selectedDataType && (this.localData.selectedDataType.id === SalaryItemDataTypes.Numerical || this.localData.selectedDataType.id === SalaryItemDataTypes.Money))
					return this.operationTypes
				else return this.operationTypes.filter(x => x.id !== SalaryItemActionTypes.Computational)
			}
		},
		watch: {
			'localData.selectedDataType': {
				deep: true,
				immediate: true,
				handler() {
					const types: any = {
						[SalaryItemDataTypes.String]: 'string',
						[SalaryItemDataTypes.Money]: 'price',
						[SalaryItemDataTypes.Numerical]: 'number',
					}
					if (this.localData.selectedDataType) this.componentOptions.defaultValue.mode = types[this.localData.selectedDataType.id]
					this.componentOptions.maxValue.mode = this.componentOptions.defaultValue.mode
					setTimeout(() => {
						let grandParentType = this.grandParentType()
						TabOrder.subscribeKeys(grandParentType, this)
					}, 500)
				}
			},
		},
		mounted() {
			this.prepareWindow(this.$t(`salary.contract.add-salary-item`), Object.values(this.topButtons))
			this.isModal = this.grandParentType() === 'modal'
			merge(this.settings, this.options)
			if (this.data) this.fillLocalData(this.data)
			if (this.isModal && this.data) this.topButtons.addButton.visible = false
			this.prepareData()

			this.getResultFunctions()
		},
		data() {
			return {
				timeMaxValue: '',
				rootExpression: {},
				isModal: false,
				resultMethods: [] as ResultFunction[],
				SalaryItemTypes,
				topButtons: {
					saveButton: {
						title: this.$t('save'),
						shortcut: $sc.find('save'),
						isPrimary: false,
						disabled: false,
						icon: 'save',
						handle: () => {
							this.save()
						},
						policyClaims: {
							or: ['Salary_SalaryItem_Add', 'Salary_SalaryItem_Edit'],
						},
						selfButton: true,
						items: [{
							title: this.$t('save-new'),
							shortcut: $sc.find('save-new'),
							isPrimary: true,
							icon: 'save',
							handle: () => {
								this.save(false)
							},
							policyClaims: {
								or: ['Salary_SalaryItem_Add', 'Salary_SalaryItem_Edit'],
							},
						}],
					},
					addButton: {
						title: this.$t('new'),
						shortcut: $sc.find('new'),
						icon: 'plus',
						isPrimary: false,
						visible: true,
						handle: () => {
							this.loadIfPossible(0)
						},
						policyClaims: 'Salary_SalaryItem_Add',
					},
					deleteButton: {
						title: this.$t('delete'),
						shortcut: $sc.find('delete', 'document'),
						icon: 'trash',
						disabled: true,
						handle: () => {
							this.showDeleteDialog()
						},
						policyClaims: 'Salary_SalaryItem_Delete',
					},
					// printButton: {
					// 	type: 'print',
					// 	navMenuKey: 'Accounting',
					// 	form: 'Document',
					// 	getDataSources: this.print_dataSources,
					// },
				},
				bottomButtons: {
					buttons_prev: {
						title: this.$t('salary.item.nav-prev'),
						shortcut: $sc.find('ctrl-move-down', 'table'),
						handle: () => {
							this.loadIfPossible(null, true, { direction: 'previous', id: (this.localData as any).id })
						},
						icon: 'angle-right',
						beginOfGroup: true,
					},
					buttons_next: {
						title: this.$t('salary.item.nav-next'),
						shortcut: $sc.find('ctrl-move-up', 'table'),
						handle: () => {
							this.loadIfPossible(null, true, { direction: 'next', id: (this.localData as any).id })
						},
						icon: 'angle-left',
					},
					buttons_refresh: {
						title: this.$t('trs.chq.oper.refresh'),
						icon: 'sync',
						handle: () => {
							this.prepareData()
						},
					},
				},
				selectedRow: [],
				items: [] as SalaryItem[],
				itemsWithoutCurrent: [] as SalaryItem[],
				functions: [] as ConvFunction[],
				variables: [] as SalaryVariable[],
				variableButtons: [
					{
						handler: this.handlerBtnVariableEdit,
						class: "no-outline text-dark",
						type: 'nk-btn',
						options: {
							visible: true,
							isPrimary: false,
							icon: 'edit',
							tooltipEnabled: true,
							hideTitle: true,
							title: this.$t('PrivilegeTypes.Edit'),
							policyClaims: 'Salary_SalaryItemVariable_Edit'
						}
					},
					{
						handler: this.handlerBtnVariableDelete,
						class: "no-outline btn-outline-danger",
						type: 'nk-btn',
						options: {
							visible: true,
							isPrimary: false,
							icon: 'trash',
							tooltipEnabled: true,
							hideTitle: true,
							title: this.$t('PrivilegeTypes.Delete'),
							policyClaims: 'Salary_SalaryItemVariable_Delete'
						}
					},
				],
				contractFields: [] as any[],
				defaultCellClass: 'px-3 nk-border-radius ',
				tableOption: {
					id: this.$options.name,
					pagination: false,

					groupIncludeTotalFooter: false,
					enterToSelect: false,
					cellSelectionAggReport: false,
					doubleClickedToSelect: true,
					rowSelection: {
						mode: 'singleRow'
					},
					sideBar: 'none',
					defaultColDef: {
						floatingFilter: false,
					},
					columnDefs: [
						{
							field: 'code',
							headerName: this.$t('salary.code'),
							width: 60
						},
						{
							field: 'name',
							headerName: this.$t('salary.item-name'),
							width: 150
						},
						{
							field: 'fillType',
							headerName: this.$t('salary.entry-method'),
							contentType: 'enum',
							cellClass: 'text-center',
							valueFormatter: (params: any): string => {
								return (this.entryTypes as any).find((x: any) => x.id === params.value)?.name
							},
							cellRenderer: nkTag,
							cellRendererParams: (params: any): any => {
								return {
									options: {
										class: this.defaultCellClass + ' ' + (this.entryTypes as any).find((x: any) => x.id === params.value)?.class,
									},
									value: (this.entryTypes as any).find((x: any) => x.id === params.value)?.name
								}
							},
						},
						{
							field: 'actionType',
							headerName: this.$t('salary.operation-type'),
							contentType: 'enum',
							cellClass: 'text-center',
							valueFormatter: (params: any): string => {
								return (this.operationTypes as any).find((x: any) => x.id === params.value)?.name
							},
							cellRenderer: nkTag,
							cellRendererParams: (params: any) => {
								return {
									options: {
										class: this.defaultCellClass + ' ' + (this.operationTypes as any).find((x: any) => x.id === params.value)?.class,
									},
									value: (this.operationTypes as any).find((x: any) => x.id === params.value)?.name
								}
							},
						},
						{
							field: 'type',
							headerName: this.$t('salary.choice-type'),
							contentType: 'enum',
							cellClass: 'text-center',
							valueFormatter: (params: any): string => {
								return (this.itemTypes as any).find((x: any) => x.id === params.value)?.name
							},
							cellRenderer: nkTag,
							cellRendererParams: (params: any) => {
								return {
									options: {
										class: this.defaultCellClass + ' ' + (this.itemTypes as any).find((x: any) => x.id === params.value)?.class,
									},
									value: (this.itemTypes as any).find((x: any) => x.id === params.value)?.name
								}
							},
						},
					]
				},
				FORM_MODES: {
					EDITABLE: 'editable',
					READONLY: 'readonly'
				},
				itemTypes: itemTypes as SelectedItemType[],
				entryTypes: entryTypes as SelectedDataEntry[],
				operationTypes: operationTypes as SelectedFunctionType[],
				dataTypes: dataTypes as SelectedDataType[],
				settings: { mode: '' },
				localData: new ConvSalaryItem(),
				originalData: new ConvSalaryItem() as ConvSalaryItem,
				componentOptions: {
					number: {
						mode: 'integer'
					},
					maxValue: { mode: SalaryItemDataTypes.String },
					maxValueDate: { mode: SalaryItemDataTypes.String },
					resultMethods: {
						searchable: true,
						required: true,
						remoteSearch: false,
						targetField: 'id',
						placeholder: this.$t('select-it'),
						display: (item: ResultFunction): string => {
							return item.name
						},
					},
					defaultValue: {},
					defaultValueDate: {},
					defaultValueTime: {
						mode: 'time',
						ltr: true
					},
					itemType: {},
					dataEntry: {},
					functionType: {},
					dataType: {},
					displayName: {},
					name: {},
					code: {
						searchable: true,
						mode: 'string',
						onSearchClick: this.allItems,
					},
					account: {
						dropdownOptions: {
							selectorHeight: '400px',
						},
					}
				} as any,
				validators: {
					localData: {
						name: validators('required'),
						selectedDataEntry: validators('required'),
						selectedItemType: validators('required'),
						selectedFunctionType: validators('required'),
						selectedDataType: validators('required'),
						jsonValue: validators(new VCustom(
							(currencyValues: any, row: any) => {
								if (row.selectedFunctionType && row.selectedFunctionType.id === SalaryItemActionTypes.Computational)
									return !!row.formula
								else return true
							},
							() => {
								return this.$t('salary.validation.messages.item-modify.jsonValue')
							}
						))
					},
				},
			}
		},
		methods: {
			getResultFunctions() {
				post(Endpoints.getUrl('salaryItem.resultFunctionList'), {}).then((res: IResponseList<ResultFunction>) => {
					this.resultMethods = res.data.items
				})
			},
			...mapActions({
				broadcastItemExist: 'socket/broadcastItemExist',
			}),
			isEmpty,
			handlerBtnVariableEdit(variable: SalaryVariable) {
				this.showModal({ component: modifyVariable, data: variable })
					.then((result) => {
						this.getVariables()
					}).catch(err => { })
			},
			handlerBtnVariableDelete(variable: SalaryVariable) {
				dialog({
					title: this.$t('salary.variable.m.delete.title'),
					body: this.$t('salary.variable.m.delete.want-to-delete', {
						name: `${variable.title}`,
					}),
					type: 'warning',
					autoClose: true,
					buttons: [
						{
							title: this.$t('dialog.yes'),
							shortcut: $sc.find('yes', 'dialog'),
							isPrimary: true,
							handle: () => {
								this.deleteVariable(variable)
							},
						},
						{
							title: this.$t('dialog.cancel'),
							shortcut: $sc.find('cancel', 'dialog'),
							isCancel: true,
							handle: () => { },
						},
					],
				})
			},
			modifyVariable() {
				this.showModal({ component: modifyVariable })
					.then((result) => {
						this.getVariables()
					}).catch(err => { })
			},
			getVariables() {
				return post(Endpoints.getUrl('salaryItemVariable.list'), {}, null, { preventConcurrent: true }).then((res: IResponseList<SalaryVariable>) => {
					this.variables = res.data.items
				}).catch(() => { })
			},
			retrieveIsEmpty(): boolean {
				return !(this.localData.id && this.localData?.id !== emptyId)
			},
			showDeleteDialog() {
				if (this.retrieveIsEmpty()) {
					return
				}
				dialog({
					title: this.$t('salary.item.m.delete.title'),
					body: this.$t('salary.item.m.delete.want-to-delete', {
						code: this.localData.code,
						name: `${this.localData.name}`,
					}),
					type: 'warning',
					autoClose: true,
					buttons: [
						{
							title: this.$t('dialog.yes'),
							shortcut: $sc.find('yes', 'dialog'),
							isPrimary: true,
							handle: () => {
								this.deleteItem()
							},
						},
						{
							title: this.$t('dialog.cancel'),
							shortcut: $sc.find('cancel', 'dialog'),
							isCancel: true,
							handle: () => { },
						},
					],
				})
			},
			addToEditor(key: string, value: any = null) {
				const charItems: IStringMap<Function> = {
					'*': this.$refs.editor.addMultiply,
					'/': this.$refs.editor.addDivide,
					'-': this.$refs.editor.addMinus,
					'+': this.$refs.editor.addPlus,
					'(': this.$refs.editor.addOpenPerantez,
					')': this.$refs.editor.addClosePerantez,
					'number': () => this.$refs.editor.addNumber(value),
					'salaryItem': (value: any) => {
						const { title, code }: { title: string, code: string } = value
						this.$refs.editor.addSalaryItem(title, code)
					},
					'function': (value: any) => {
						const { displayName, func, min, max }: {
							displayName: string,
							func: string,
							min: number,
							max: number
						} = value
						this.$refs.editor.addFunction(displayName, func, min, max)
					},
					'variable': (value: any) => {
						const { displayName, code }: { displayName: string, code: string } = value
						this.$refs.editor.addVariable(displayName, code)
					},
					'contractField': (value: any) => {
						const { displayName, field }: { displayName: string, field: string } = value
						this.$refs.editor.addContractField(displayName, field)
					},
				}
				if (charItems[key]) charItems[key](value)
			},
			getItemListData(requestOptions: any = null): Promise<any> {
				return post(Endpoints.getUrl('salaryItem.list'), {}, null, { preventConcurrent: true, ...requestOptions }).then((res: IResponseList<SalaryItem>) => {
					this.items = res.data.items.filter((x: SalaryItem) => x.actionType !== SalaryItemActionTypes.Display && x.id !== this.localData.id)
					this.itemsWithoutCurrent = this.items
				}).catch(() => { })
			},
			async prepareData() {
				const getFunctions = () => {
					return post(Endpoints.getUrl('salaryItem.functionList'), {}, null, { preventConcurrent: true }).then((res: any) => {
						this.functions = res.data.functions.map((x: ConvFunction) => {
							return {
								...new ConvFunction(x),
							}
						})
					}).catch(() => { })
				}
				const getContractFields = () => {
					return post(Endpoints.getUrl('Contract.GetContractFields'), {}, null, { preventConcurrent: true }).then((res: any) => {
						this.contractFields = res.data.map((x: any) => {
							return {
								...x,
								pName: this.$t(`salary.contract.field.${x.name}`)
							}
						})
					}).catch(() => { })
				}
				var wait = this.$wait(this.$el)
				await Promise.all([this.getItemListData(), getFunctions(), getContractFields(), this.getVariables()])
				wait.end()
			},
			clearForm() {
				this.setFormMode()
				this.localData = new ConvSalaryItem()
				this.originalData = cloneDeep(this.localData)
				this.$refs.inputCode.$el.focus()
				this.topButtons.deleteButton.disabled = isEmpty(this.localData.id)
				this.$refs.editor.reset()
				this.itemsWithoutCurrent = this.items
				this.timeMaxValue = ''
			},
			fillLocalData(data: ConvSalaryItem) {
				if (isEmpty(data.accountId)) data.accountId = ''
				this.localData = new ConvSalaryItem(data)
				this.originalData = cloneDeep(this.localData)
				this.topButtons.deleteButton.disabled = isEmpty(this.localData.id)
				this.itemsWithoutCurrent = this.items.filter((x: any) => x.id !== this.localData.id)
				if (data.dataType === SalaryItemDataTypes.Time && data.maxValue) {
					this.timeMaxValue = `${Math.trunc(data.maxValue)}:${Math.trunc(Number((data.maxValue % 1).toFixed(4)) * 60).toLocaleString('en-US', { minimumIntegerDigits: 2 })}:00`
				}
			},
			getByCode(request: any) {
				return new Promise((resolve, reject) => {
					var url = Endpoints.getUrl('salaryItem.get')
					var wait = this.$wait(this.$refs.inputCode.$el, { size: 'small' })
					post(url, { code: request.searchCode }, null, { silent: true })
						.then((result: IResponse<any>) => {
							wait.end()
							resolve(new ConvSalaryItem(result.data))
						})
						.catch((err: any) => {
							wait.end()
							reject(err)
						})
				})
			},
			setFormMode(item?: ConvSalaryItem) {
				if (!this.options || !this.options.mode)
					this.settings.mode = this.FORM_MODES.EDITABLE
				this.topButtons.saveButton.disabled = this.settings.mode === this.FORM_MODES.READONLY
				this.topButtons.deleteButton.disabled = this.settings.mode === this.FORM_MODES.READONLY || item?.id === emptyId
			},
			validateInputs(data: ConvSalaryItem) {
				let checker = new Checker((name: string) => this.$t(`salary.validation.messages.item-modify.${name}`))
				let errors = checker.test(data, this.validators.localData)
				if (this.localData.selectedFunctionType?.id === SalaryItemActionTypes.Computational && !this.$refs.editor.validate()) errors.push({ key: 'jsonFormula2', error: this.$t('salary.validation.messages.item-modify.incorrect-formula-expression') })
				this.validationToast(errors)
				return errors.length === 0
			},
			save(closeWindow: boolean = true) {
				return new Promise((resolve, reject) => {
					let url
					if (isEmpty(this.localData.id)) {
						url = Endpoints.getUrl('salaryItem.create')
					} else {
						url = Endpoints.getUrl('salaryItem.update')
					}
					let data = cloneDeep(this.localData) as ConvSalaryItem
					if (data.defaultValue || data.defaultValue == 0) data.defaultValue = data.defaultValue.toString()
					if (data.selectedDataType?.id === SalaryItemDataTypes.Time && this.timeMaxValue) {
						data.maxValue = Number(this.timeMaxValue.split(':')[0]) + (Number(this.timeMaxValue.split(':')[1]) / 60)
					}
					// if (this.localData.maxValue) this.localData.maxValue = this.localData.maxValue.toString()
					if (!data.selectedAccount) data.accountId = emptyId
					if (data.selectedFunctionType && data.selectedFunctionType.id === SalaryItemActionTypes.Computational) {
						data.jsonFormula = this.$refs.editor.getJsonValue()
						data.formula = this.$refs.editor.getFormatValue()
					}
					if (this.validateInputs(data)) {
						let wait = this.$wait(this.grandParent)
						post(url, { salaryItem: data })
							.then((response: IResponse<any>) => {
								wait.end()
								this.$toast(this.$t('salary.item.m.create-success', { name: data.name, code: response.data.code }), { type: TYPE.SUCCESS })
								this.broadcastItemExist({ form: this.$t('salary.item.item'), code: response.data.code })
								if (this.isModal && closeWindow)
									this.resolve(response.data)
								else {
									this.clearForm()
									this.getItemListData()
								}
							})
							.catch(() => {
								wait.end()
							})
					}
				})
			},
			deleteItem() {
				var wait = this.$wait(this.grandParent)
				const { code, name } = this.localData
				post(Endpoints.getUrl('salaryItem.delete'), {
					salaryItemId: this.localData.id,
				})
					.then((result: IResponse<any>) => {
						wait.end()
						this.$toast(this.$t('salary.item.m.delete.success-body', {
							code,
							name: `${name}`,
						}), { type: TYPE.SUCCESS })
						this.getItemListData()
						this.clearForm()
					})
					.catch(() => {
						wait.end()
					})
			},
			deleteVariable(variable: SalaryVariable) {
				var wait = this.$wait(this.grandParent)
				post(Endpoints.getUrl('salaryItemVariable.delete'), {
					salaryItemVariableId: variable.id,
				})
					.then((result: IResponse<any>) => {
						this.$toast(this.$t('salary.variable.m.delete.success-body', {
							name: `${variable.title}`,
						}), { type: TYPE.SUCCESS })
						this.getVariables()
					})
					.catch(() => {
					}).finally(() => wait.end())
			},
			changedFormAlert(act: Function, params: any) {
				return new Promise((resolve: Function, reject: Function) => {
					dialog({
						title: this.$t('salary.item.m.unsaved-item-title'),
						body: this.$t('salary.item.m.unsaved-item-body', {
							productCode: this.originalData?.code,
						}),
						buttons: [
							{
								title: this.$t('document.dialog.saveAsSaved'),
								shortcut: $sc.find('yes', 'dialog'),
								isPrimary: true,
								handle: () => {
									this.localData.code = this.originalData?.code
									this.save()
										.then((response) => {
											this.$refs.inputCode.$el.focus()
											act(params)
										})
										.then(() => resolve())
										.catch((error) => reject(error))
								},
							},
							{
								title: this.$t('document.dialog.ignoreChanges-load'),
								shortcut: $sc.find('ignore-changes', 'document'),
								isPrimary: true,
								handle: () => {
									act(params)
									resolve()
								},
							},
							{
								title: this.$t('dialog.return'),
								shortcut: $sc.find('return', 'dialog'),
								isCancel: true,
								handle: () => {
									reject()
								},
							},
						],
					})
				})
			},
			isDataChanged() {
				return new Promise((resolve: Function, reject: Function) => {
					let localData_cloned = cloneDeep(this.localData)
					let originalProduct_cloned = cloneDeep(this.originalData)
					localData_cloned.code = originalProduct_cloned?.code
					resolve(!!originalProduct_cloned && !isEqual(originalProduct_cloned, localData_cloned))
				})
			},
			navigateTo(direction: string, _id: string) {
				let wait = this.$wait(this.grandParent)
				const id = _id ? _id : this.localData.id
				let data = {
					id: id === emptyId ? null : id,
					navigationDirection: direction,
				}
				return new Promise((resolve, reject) => {
					post(Endpoints.getUrl('salaryItem.navigate'), data, null, { silent: true })
						.then((result: IResponse<any>) => {
							wait.end()
							resolve(result.data)
						})
						.catch((err: any) => {
							wait.end()
							reject(err)
						})
				})
			},
			loadIfPossible(code: string, useToast = true, navigateOptions: any = null, forceLoad: boolean = false) {
				let methods = {
					retreiveIsEmpty: () => isEmpty(this.localData.id),
					fillData: this.fillLocalData,
					getData: this.getByCode,
					clearForm: this.clearForm,
					changedFormAlert: this.changedFormAlert,
					isDataChanged: this.isDataChanged,
					navigate: this.navigateTo,
					forceLoad: () => forceLoad,
					save: this.save,
				}
				let data = {
					originalData: this.originalData,
					searchCode: code
				}
				this.$nikan.formUtility.loadIfPossible(methods, data, { keyword: this.$t('salary.item.item'), useToast: useToast }, navigateOptions)
			},
			allItems() {
				this.showModal({ component: salaryItemList, options: { excludeDisabledItems: false } })
					.then((result) => {
						this.loadIfPossible(result.code)
						this.defer(() => this.$refs.inputCode.$el.focus(), 1)
					}).catch(err => { })
			},
			onBlurCode() {
				if (this.localData.code)
					this.loadIfPossible(this.localData.code)
			},
			ignoreNonPrivilegeCalcChanged(val: boolean) {
				this.localData.ignoreNonPrivilegeCalc = val

				if (val) {
					this.localData.includeTax = false
					this.localData.includeInsurance = false
				}
			}
		}
	})
</script>

<style scoped>
	.stab-height {
		height: 510px;
		overflow: hidden;
	}

	div.cursor-pointer>label {
		cursor: pointer;
	}
</style>